// src/componentLoader.ts
import { lazy } from 'react'

export const componentLoader = {
  container: () => lazy(() => import('./elements/container')),
  flex: () => lazy(() => import('./elements/flex')),
  text: () => lazy(() => import('./elements/text')),
  input: () => lazy(() => import('./elements/input')),
  textarea: () => lazy(() => import('./elements/textarea')),
  button: () => lazy(() => import('./elements/button')),
  image: () => lazy(() => import('./elements/image')),
  video: () => lazy(() => import('./elements/video')),
  dropdown: () => lazy(() => import('./elements/dropdown')),
  svgcontainer: () => lazy(() => import('./elements/svgcontainer')),
  svgrect: () => lazy(() => import('./elements/svgrect')),
  svgcircle: () => lazy(() => import('./elements/svgcircle')),
  svgellipse: () => lazy(() => import('./elements/svgellipse')),
  svgline: () => lazy(() => import('./elements/svgline')),
  svgpolyline: () => lazy(() => import('./elements/svgpolyline')),
  svgpolygon: () => lazy(() => import('./elements/svgpolygon')),
  svgpath: () => lazy(() => import('./elements/svgpath')),
  anime: () => lazy(() => import('./elements/anime')),
  jsoneditor: () => lazy(() => import('./elements/jsoneditor')),
  calendar: () => lazy(() => import('./elements/calendar')),
  upload: () => lazy(() => import('./elements/upload')),
  chart: () => lazy(() => import('./elements/chart')),
  table: () => lazy(() => import('./elements/table')),
  iframe: () => lazy(() => import('./elements/iframe')),
  dateinput: () => lazy(() => import('./elements/dateinput')),
  qrcodescanner: () => lazy(() => import('./elements/qrcodescanner')),
  virtuallist: () => lazy(() => import('./elements/virtuallist')),
  three: () => lazy(() => import('./elements/three-fiber')),
}
